<template lang="pug">
.flowSteps
  .nodetitle(v-if="source !=='h5'")
    span 流程处理人
    i(class="el-icon-close" title="关闭流程处理人" v-if="flowType !== 2 && flowType !== 3" @click="stepsClose")
  .nodeShowList(v-loading="stepsLoading" element-loading-text="流程节点加载中...")
    //- 发起流程使用
    .user-steps(v-if="flowType === 1||flowType === 4||flowType === 5")
      el-collapse(v-model="activeNode")
        el-collapse-item(v-for="(item, index) in nodeList"  :key="index" :name="item.id")
          template(#title)
            .top
              .circle
              span(v-if="!item.isHistory") {{item.nodeName}}
              span(v-else) 记录：{{item.flowNodeName}}
                span.flowNodeStatus(:class="`typeNode${item.nodeStatus}`") {{nodeStatusName(item.nodeStatus)}}
          .description(v-if="!item.isHistory")
            //- 审批人
            .user-title
              span 审批人：
              span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
              i.el-icon-circle-plus.addStyleApprove(
                v-if="canAddApprover(item)"
                title="范围内添加审批人"
                @click="addApprover(item.flowNodeDefinitionId,item.assigneeList)")
            userItem(
              v-if="item.assigneeList.length>0"
              :userList="changeUserName(item.assigneeList)"
              :disabled="!canAddApprover(item)"
              @deleteUser="deleteApproveAss(item.flowNodeDefinitionId,$event)")
            span.expr(v-else) {{item.conditionExpr}}
            //- 抄送人
            .user-title(v-if="item.ccList.length>0")
              span 抄送人：
              i.el-icon-circle-plus.addStyleApprove(title="选择人员" @click="addCCUser(item.flowNodeDefinitionId,item.ccList)")
            userItem(
              v-if="item.ccList.length>0"
              :userList="changeUserName(item.ccList)"
              :disabled="item.ccOptional!==1"
              @deleteUser="deleteApproveCC(item.flowNodeDefinitionId,$event)")
          //- 流程再发起展示的历史数据
          .description(v-else)
            .user-title 审批人：
              span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
            userListApprove(:userList="item.assigneeList" :disabled="true" :nodeStatus="item.nodeStatus" :result="item.result"
              v-if="item.assigneeList.length>0")
            .user-title(v-if="item.ccList.length>0") 抄送人：
            userList.outline(ref="userList" line="inline" disabled :jobNo="false" :list="changeUserName(item.ccList)" v-if="item.ccList.length>0")
            //- span.noUser(v-else) （无抄送人）
            //- userList.outline(ref="userList" line="inline" disabled :jobNo="false" :list="changeUserName(item.ccList)" v-if="item.ccList.length>0")
    //- 审批、查看流程使用
    .user-steps(v-if="flowType === 2||flowType === 3")
      el-collapse(v-model="activeNode")
        el-collapse-item(v-for="(item, index) in nodeList"  :key="index" :name="item.flowNodeId")
          template(#title)
            .top
              .circle(:class="{'ischeck': item.nodeStatus ==='2'}")
              span {{item.flowNodeName}}
              span.flowNodeStatus(:class="`typeNode${item.nodeStatus}`") {{nodeStatusName(item.nodeStatus)}}
          .description(:class="{'ischeck': item.nodeStatus ==='2'}")
            .user-title 审批人：
              span.multiUserDealStrategy(v-if="item.assigneeList.length>1") {{item.multiUserDealStrategy===1?"或签":"会签"}}
              i.el-icon-circle-plus.addStyleApprove(v-if="item.allowAddApproverDynamic===1 && flowType === 2 && item.nodeStatus !=='1'"
                title="选择人员" @click="openNextNode(item)")
            //- 审批处理
            userListApprove(:userList="item.assigneeList" :uuid="uuid"  :nodeStatus="item.nodeStatus" :result="item.result" :disabled="true"
              v-if="(item.allowAddApproverDynamic !==1 ||flowType === 3||item.nodeStatus ==='1') && item.assigneeList && item.assigneeList.length>0")
            userItem(:userList="item.assigneeList" v-else-if="item.assigneeList && item.assigneeList.length>0"
              @deleteUser="deleteApproveAss(item.flowNodeDefinitionId,$event)")
            span.noUser(v-else) （无审批人）
            .accept(v-if="accepApprove(item.nodeStatus,item.assigneeList)")
              userApprove(ref="userApprove"  :uuid="uuid" :source="source" @closeDialog="closeDialog" :getBasicData="getBasicData")
            .accept(v-if="item.allowAddNode === 1 && flowType === 2 && item.nodeStatus !=='1'")
              addApproveNode(ref="addApproveNode" :uuid="uuid" :source="source")
            .user-title(v-if="item.ccList.length>0")
              span 抄送人：
              i.el-icon-circle-plus.addStyleApprove(title="选择抄送人" v-if="accepApprove(item.nodeStatus,item.assigneeList)"
                @click="addCCUser(item.flowNodeDefinitionId,item.ccList)")
            userItem(:userList="changeUserName(item.ccList)" :disabled="item.nodeStatus!=='2'" v-if="item.ccList.length>0")
    .footer
      .flowInline
        .title 流程完后抄送人
        el-button.addPeople(icon="el-icon-plus" type="text" title="选择人员" @click="openPerson(flowCcList)"
          v-if="flowType !== 2 && flowType !== 3") 添加抄送人
      userItem(:userList="flowCcList" :disabled="flowType === 2||flowType === 3" v-if="flowCcList.length>0" @deleteUser="deleteAssUser")
      span.noUser(v-else) （无抄送人）
</template>

<script>
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { openMember, openH5Member } from "@/CommonDP/components/chooseMember/leftCom.js";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import userListApprove from "@/CommonDP/components/processComponents/flowNewConfig/userListApprove.vue";
import userApprove from "@/CommonDP/components/processComponents/flowNewConfig/userApprove.vue";
import addApproveNode from "@/CommonDP/components/processComponents/flowNewConfig/addApproveNode.vue";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
export default {
  components: { userListApprove, userApprove, addApproveNode, userItem },
  props: {
    getBasicData: { type: Function, default: null },
    uuid: { type: String, default: "" },
    source: { type: String, default: "pc" }
  },
  data() {
    return {
      currentIndex: 0,
      stepsLoading: false,
      formData: {},
      activeNode: 0,
      isItemCCList: false // 是否允许申请人选择抄送人
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo
    }),
    codePri() {
      return ["User", "SystemRole", "SpecRole", "PrjRole"];
    },
    // 流程类型 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
    flowType() {
      return getApprove(this.uuid).flowType;
    },
    prjId() {
      return getApprove(this.uuid)?.getPrjId() || "";
    },
    flowInfo() {
      return getApprove(this.uuid)?.getMessage();
    },
    flowCcList() {
      return this.flowInfo?.ccList || [];
    },
    nodeList() {
      return getApprove(this.uuid)?.getFlowNodeDtoList();
    },
    flowInstanceId() {
      return this.flowInfo.flowInstanceId;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.stepsLoading = true;
      if (this.flowType === 1 || this.flowType === 4) {
        this.activeNode = this.nodeList?.map((e) => e.id) || [];
        this.stepsLoading = false;
      }
      if (this.flowType === 5) {
        await this.getHistoryNode();
        this.activeNode = this.nodeList?.filter((e) => !e.isHistory).map((e) => e.id) || [];
        this.stepsLoading = false;
      }
      if (this.flowType === 2) {
        const currentIndex = this.nodeList.findIndex((e) => e.nodeStatus === "2");
        if (currentIndex > 0) this.activeNode = this.nodeList[currentIndex].flowNodeId;
        else this.activeNode = this.nodeList?.map((e) => e.flowNodeId);
        this.stepsLoading = false;
      }
      if (this.flowType === 3) {
        this.activeNode = this.nodeList?.map((e) => e.flowNodeId) || [];
        this.stepsLoading = false;
      }
    },
    async getHistoryNode() {
      const res = await flowService.queryFlowNodeAllList(this.flowInstanceId);
      const list = res.data?.map((e) => {
        return {
          ...e,
          id: "old" + e.flowNodeId,
          isHistory: true
        };
      });
      getApprove(this.uuid)?.addFlowNodeHistoryList(list);
    },
    // 添加该节点审批人
    async addApprover(flowNodeDefinitionId, assigneeList) {
      const props = {
        filterOneself: false,
        codePri: ["User", "Label"],
        isLowcode:true,
        type:6,
        prjId: this.prjId,
        userIds: assigneeList?.map((e) => e.userId)?.join(",") || ""
      };
      const users = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
      const list = await this.getRealUserList(users);
      getApprove(this.uuid)?.addFlowNodeDtoList(flowNodeDefinitionId, list, "ass");
    },
    // 节点抄送人
    async addCCUser(flowNodeDefinitionId, ccList) {
      const props = {
        filterOneself: false,
        codePri: ["User", "Label"],
        prjId: this.prjId,
        isLowcode:true,
        type:6,
        userIds: ccList?.map((e) => e.userId)?.join(",") || ""
      };
      const users = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
      const list = await this.getRealUserList(users);
      getApprove(this.uuid)?.addFlowNodeDtoList(flowNodeDefinitionId, list, "cc");
    },
    // async addApproveCCUser(flowNodeDefinitionId, ccList) {
    //   const props = {
    //     filterOneself: false,
    //     codePri: ["User", "Label"],
    //     userIds: ccList?.map((e) => e.userId)?.join(",") || ""
    //   };
    //   const users = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
    //   const list = await this.getRealUserList(users);
    //   getApprove(this.uuid)?.addFlowNodeDtoList(flowNodeDefinitionId, list, "cc");
    // },
    // 删除发起审批的审批人
    deleteApproveAss(flowNodeDefinitionId, user) {
      this.deleteApprove(flowNodeDefinitionId, user, "ass");
    },
    // 删除发起审批的抄送人
    deleteApproveCC(flowNodeDefinitionId, user) {
      this.deleteApprove(flowNodeDefinitionId, user, "cc");
    },
    // 删除流程完毕后的抄送人
    deleteAssUser(user) {
      getApprove(this.uuid)?.deleteAssUser(user.userId);
    },
    deleteApprove(flowNodeDefinitionId, user, type) {
      getApprove(this.uuid)?.deleteFlowNodeDtoList(flowNodeDefinitionId, user.userId, type);
    },
    // 流程完后抄送人
    async openPerson(flowCcList) {
      const props = {
        filterOneself: false,
        codePri: ["User", "Label"],
        prjId: this.prjId,
        isLowcode:true,
        type:6,
        userIds: flowCcList?.map((e) => e.userId)?.join(",") || ""
      };
      const users = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
      const list = await this.getRealUserList(users);
      getApprove(this.uuid)?.setCcUserIdList(list);
    },
    // 审批选择下一个节点的审批人
    async openNextNode(item) {
      const props = {
        filterOneself: false,
        codePri: ["User", "Label"],
        prjId: this.prjId,
        isLowcode:true,
        type:6,
        usersList: []
      };
      const users = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
      const list = await this.getRealUserList(users);
      getApprove(this.uuid)?.addFlowNodeDtoList(item.flowNodeDefinitionId, list, "ass");
    },

    handleStep(index) {
      this.currentIndex = index;
      // this.nodeDetail = node;
    },
    stepsClose() {
      this.$emit("stepsClose");
    },
    async getRealUserList(users = []) {
      // 标签list
      const tagList = users.filter((e) => e.selectCode === "Label");
      // 人员列表
      const userList = users.filter((e) => e.selectCode !== "Label");
      // 标签ids
      const tagIds = tagList.map((e) => e.userId);
      if (tagIds.length) {
        const { data = [] } = await flowService.queryTagUserList(tagIds);
        for (const iterator of data) {
          if (!userList.some(e => e.userId === iterator.userId)) {
            userList.push({
              ...iterator,
              selectId: iterator.userId,
              selectName: iterator.name + "(" + iterator.username + ")"
            });
          }
        }
      }
      return userList;
    },
    nodeStatusName(status) {
      const statusDesccribe = {
        1: () => "已同意",
        10: () => "自动通过",
        2: () => "审批中",
        3: () => "发起",
        4: () => "再发起",
        5: () => "已撤回",
        8: () => "已终止",
        0: () => "已驳回"
      };
      return statusDesccribe[status] ? statusDesccribe[status]() : "";
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    // 是否需要审批
    accepApprove(nodeStatus, assigneeList) {
      return nodeStatus === "2" && assigneeList.some((e) => e.result === "2" && e.userId === this.userInfo.userId) && this.flowType === 2;
    },
    changeUserName(list) {
      return list.map((e) => {
        return {
          ...e,
          selectCode: "User",
          name: e.userName
        };
      });
    },
    // 审批人列表 过滤 type=0 审批人 type=1 被抄送人
    approverList(userDtoList) {
      return this.changeUserName(userDtoList.filter((e) => e.type === 0));
    },
    // 是否显示审批人列表
    showApproveList(item) {
      const list = this.approverList(item);
      return list.length > 0;
    },
    // 能否添加审批人
    canAddApprover(item) {
      return item.canChangeAssignee === 1 || item.assigneeSelectionStrategy === "2" ;
    }
  }
};
</script>
<style lang="scss" scoped>
.flowSteps {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-left: 10px;
}

.nodetitle {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebefff;
  margin-bottom: 10px;

  span {
    font-weight: 700;
    font-size: 16px;
    line-height: 40px;
    color: var(--theme-color);
  }

  i {
    cursor: pointer;
  }
}

.nodeShowList {
  width: 100%;
  height: calc(100% - 50px);
  padding-right: 5px;
  overflow-x: hidden;
  overflow-y: auto;
}

.user-steps {
  width: 100%;
  display: flex;
  flex-direction: column;

  .user-step {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
}
.description {
  margin-left: 7px;
  border-left: 2px solid #c0c4cc;
  padding-left: 10px;
  display: flex;
  flex-direction: column;

  .user-title {
    font-size: 12px;
    line-height: 20px;
    color: var(--theme-color);
    display: flex;
    flex-direction: row;
    align-items: center;

    .multiUserDealStrategy {
      margin-left: 5px;
      font-size: 12px;
      line-height: 20px;
      color: #606266;
    }
    .addStyleApprove {
      margin-left: 5px;
      font-size: 22px;
      line-height: 20px;
      color: var(--theme-color);
      cursor: pointer;
    }
  }
}
.ischeck {
  border-left: 2px solid var(--theme-color);
}
.top {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .circle {
    width: 16px;
    height: 16px;
    background-color: #c0c4cc;
    border-radius: 8px;
  }
  .ischeck {
    background-color: var(--theme-color) !important;
  }

  span {
    margin-left: 7px;
    font-size: 14px;
    font-weight: 700;
  }
}
/deep/.el-collapse {
  border-top: 0;
}
/deep/.el-collapse-item__content {
  padding-bottom: 10px;
}
.ischeck {
  /deep/.circle {
    background-color: var(--theme-color) !important;
  }

  /deep/.description {
    border-left: 2px solid var(--theme-color) !important;
  }
}

.outline {
  border: none;
  padding-left: 0 !important;
  // display: flex;
  // align-items: flex-start;
}

.expr {
  font-size: 14px;
  line-height: 35px;
}
.noUser {
  font-size: 12px;
  color: var(--info-color);
}
.footer {
  margin-top: 10px;
}

.flowInline {
  display: flex;
  flex-direction: row;
  align-items: center;

  .title {
    font-size: 16px;
    line-height: 23px;
    color: var(--theme-color);
  }

  .addPeople {
    margin-left: 5px;
  }
}
.flowNodeStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
  font-size: 12px !important;
  line-height: 16px;
  font-weight: 400 !important;
}
.typeNode1,
.typeNode10,
.typeNode4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.typeNode2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.typeNode3,.typeNode4{
  border: 1px solid #00BCD4;
  background: rgba(0, 188, 212, 0.10);
  color: #00BCD4;
}

.typeNode5 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.typeNode8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.typeNode9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.typeNode0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}
</style>
